import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-container !content-start pt-8" }
const _hoisted_2 = { class: "actions-row flex items-center justify-start gap-4 col-start-1 col-end-13" }
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 0,
  class: "col-start-1 col-end-13 w-full p-4 text-2xl rounded bg-white min-h-[50vh]"
}
const _hoisted_6 = {
  key: 1,
  class: "col-start-1 col-end-13 w-full p-4 text-2xl rounded bg-white min-h-[50vh]"
}
const _hoisted_7 = { class: "text-4xl font-semibold mt-4 mb-8" }
const _hoisted_8 = { class: "bg-blue-500 rounded flex items-center gap-4 text-white p-4 mb-16" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "flex gap-16 items-stretch justify-between" }
const _hoisted_11 = { class: "acp-container w-full flex flex-col items-start" }
const _hoisted_12 = {
  key: 0,
  class: "text-3xl font-semibold mb-8"
}
const _hoisted_13 = { class: "upload-container w-full" }
const _hoisted_14 = {
  key: 0,
  class: "upload-container w-full"
}
const _hoisted_15 = { class: "bg-yellow-500 rounded flex items-start gap-4 text-white p-4 mb-16" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["href"]
const _hoisted_18 = { class: "soest-container flex flex-col items-start w-full" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl font-semibold mb-8" }, "Soest Excel", -1)
const _hoisted_20 = {
  key: 0,
  class: "upload-container w-full"
}
const _hoisted_21 = { class: "bg-yellow-500 rounded flex items-start gap-4 text-white p-4 mb-16" }
const _hoisted_22 = ["src"]
const _hoisted_23 = ["href"]
const _hoisted_24 = {
  key: 1,
  class: "upload-container w-full"
}

import { onMounted, ref, computed } from "vue";
    import fileUploadFlexible from "../reusable/fileUploadFlexible.vue"
    import { useRoute } from "vue-router";
    import { useStore } from "vuex";
    import bmsMethods from "../../mixins/bms/bmsMethods";
    import { useGetOMProject, checkDataForSelectedPeriod, postExcelFile } from "../../composables/omPlatformFunctions";
    import acLoader from "../reusable/acLoader.vue";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'omSingleProject',
  setup(__props) {


    const route = useRoute();
    const store = useStore();
    const userName = computed(() => store.getters["user/userProfile"].name)
    const projectId = route.query.id as string;

    const existingFiles = ref<object | undefined>(undefined)
    
    const isOverridingExistingACP = ref<boolean>(false)
    const isOverridingExistingSoest = ref<boolean>(false)

    const { project, isLoadingProject } = useGetOMProject(projectId);

    const yearOptions = [
        "2023",
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
    ]

    const months = [
    { id: "01", monthName: "Ocak" },
    { id: "02", monthName: "Şubat" },
    { id: "03", monthName: "Mart" },
    { id: "04", monthName: "Nisan" },
    { id: "05", monthName: "Mayıs" },
    { id: "06", monthName: "Haziran" },
    { id: "07", monthName: "Temmuz" },
    { id: "08", monthName: "Ağustos" },
    { id: "09", monthName: "Eylül" },
    { id: "10", monthName: "Ekim" },
    { id: "11", monthName: "Kasım" },
    { id: "12", monthName: "Aralık" }
    ];

   const selectedYear = ref<string>(new Date().getFullYear().toString());
   const selectedMonth = ref<object>(months[new Date().getMonth()]);

    const postOMFile = async (fileCategory: string, file) => {

        const selectedFile = file[0]

         const filePath = await bmsMethods.methods.uploadSingleToBMS(selectedFile, `onlineMonitoring/${projectId}/${selectedYear.value}/${selectedMonth.value.id}`, )

         const OMData = {
            uploadedBy: userName.value,
            path: filePath,
         }
         
         if(fileCategory === 'acp'){
            try{
                await postExcelFile(projectId, selectedYear.value, selectedMonth.value.id,  OMData, 'acpExcel')
            } catch(e){
                alert(`Bir hata oluştu: ${e}. Lütfen tekrar deneyin ve bu hata mesajını yazılım ekibiniz ile paylaşın`)
            }
         } else if (fileCategory === 'soest'){
            try{
                await postExcelFile(projectId, selectedYear.value, selectedMonth.value.id, OMData, 'soestExcel')
            }catch(e){
                alert(`Bir hata oluştu: ${e}. Lütfen tekrar deneyin ve bu hata mesajını yazılım ekibiniz ile paylaşın`)
            }
         }

        onDateChanged()
    }

    const onDateChanged = ( async () => {
        existingFiles.value = undefined
        isLoadingProject.value = true
        existingFiles.value = await checkDataForSelectedPeriod(projectId, selectedYear.value, selectedMonth.value.id)
        isLoadingProject.value = false
    } )

    onMounted( async () => {
        isLoadingProject.value = true
        existingFiles.value = await checkDataForSelectedPeriod(projectId, selectedYear.value, selectedMonth.value.id)
        isLoadingProject.value = false
    })



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("select", {
        onChange: onDateChanged,
        class: "outline-none px-8 py-2 rounded-lg bg-white text-2xl",
        name: "year",
        id: "year",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedYear).value = $event))
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(yearOptions, (year) => {
          return _createElementVNode("option", {
            key: year,
            value: year
          }, _toDisplayString(year), 9, _hoisted_3)
        }), 64))
      ], 544), [
        [_vModelSelect, selectedYear.value]
      ]),
      _withDirectives(_createElementVNode("select", {
        onChange: onDateChanged,
        class: "outline-none px-8 py-2 rounded-lg bg-white text-2xl",
        name: "month",
        id: "month",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedMonth).value = $event))
      }, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(months, (month) => {
          return _createElementVNode("option", {
            key: month.id,
            value: month
          }, _toDisplayString(month.monthName), 9, _hoisted_4)
        }), 64))
      ], 544), [
        [_vModelSelect, selectedMonth.value]
      ])
    ]),
    (_unref(isLoadingProject))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(acLoader, { class: "!top-[35%] h-full left-[50%] !absolute" })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("h1", _hoisted_7, _toDisplayString(_unref(project).name), 1),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("img", {
              width: "24",
              class: "brightness-0 invert",
              src: require('../../assets/icons/info-icon.png')
            }, null, 8, _hoisted_9),
            _createTextVNode(" Şu anda "),
            _createElementVNode("strong", null, _toDisplayString(selectedMonth.value.monthName) + " - " + _toDisplayString(selectedYear.value), 1),
            _createTextVNode(" için verileri güncelliyorsunuz. Lütfen yükleme işleminden önce, üst bölümden doğru ay ve yıl bilgisinin seçili olduğundan emin olun. ")
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (!isOverridingExistingACP.value)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_12, "ACP Excel"))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                (existingFiles.value['acpExcel'] && !isOverridingExistingACP.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("img", {
                          width: "24",
                          class: "",
                          src: require('../../assets/icons/warning.png')
                        }, null, 8, _hoisted_16),
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(selectedMonth.value.monthName) + " - " + _toDisplayString(selectedYear.value) + " için ACP Excel dosyası zaten yüklenmiş. Dosyayı görüntülemek için lütfen ", 1),
                          _createElementVNode("a", {
                            target: "_blank",
                            class: "underline",
                            href: existingFiles.value.acpExcel.path
                          }, " buraya tıklayın", 8, _hoisted_17),
                          _createTextVNode(". Eğer yeniden yüklemek istiyorsanız, lütfen aşağıdaki butona tıklayın.")
                        ])
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (isOverridingExistingACP.value = true)),
                        class: "ac-primary-button bg-white border border-black text-black"
                      }, "Yeniden Yükle")
                    ]))
                  : (_openBlock(), _createBlock(fileUploadFlexible, {
                      key: 1,
                      onFilesChanged: _cache[3] || (_cache[3] = ($event: any) => (postOMFile('acp', $event))),
                      "single-file": true,
                      allow: ['.xls', '.xlsx',]
                    }, null, 8, ["allow"]))
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              (existingFiles.value['soestExcel'] && !isOverridingExistingSoest.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("img", {
                        width: "24",
                        class: "",
                        src: require('../../assets/icons/warning.png')
                      }, null, 8, _hoisted_22),
                      _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(selectedMonth.value.monthName) + " - " + _toDisplayString(selectedYear.value) + " için Soest Excel dosyası zaten yüklenmiş. Dosyayı görüntülemek için lütfen ", 1),
                        _createElementVNode("a", {
                          target: "_blank",
                          class: "underline",
                          href: existingFiles.value.soestExcel.path
                        }, " buraya tıklayın", 8, _hoisted_23),
                        _createTextVNode(". Eğer yeniden yüklemek istiyorsanız, lütfen aşağıdaki butona tıklayın.")
                      ])
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (isOverridingExistingSoest.value = true)),
                      class: "ac-primary-button bg-white border border-black text-black"
                    }, "Yeniden Yükle")
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createVNode(fileUploadFlexible, {
                      onFilesChanged: _cache[5] || (_cache[5] = ($event: any) => (postOMFile('soest', $event))),
                      "single-file": true,
                      allow: ['.xls', '.xlsx',]
                    }, null, 8, ["allow"])
                  ]))
            ])
          ])
        ]))
  ]))
}
}

})